import { isUnscheduledAppointment } from 'Data/format.js'

export function getView(event) {
  return !isUnscheduledAppointment(event.appointment)
    ? 'Scheduled'
    : 'Unscheduled'
}
